import { render } from "./Paginated.vue?vue&type=template&id=12f91cde&scoped=true"
import script from "./Paginated.vue?vue&type=script&lang=js"
export * from "./Paginated.vue?vue&type=script&lang=js"

import "./Paginated.vue?vue&type=style&index=0&id=12f91cde&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f91cde"]])

export default __exports__